<template>
    <div class="linkHoverSmall" style="font-size:16px !important">
        {{comment}}
    </div>
</template>
<script>
export default {
    name: "FeedbackPercentage",
    props: {
        comment: String,
    },
}
</script>